'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OktaContext = require('./OktaContext');

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RequireAuth = function RequireAuth(_ref) {
  var children = _ref.children;

  var _useOktaAuth = (0, _OktaContext.useOktaAuth)(),
      authService = _useOktaAuth.authService,
      authState = _useOktaAuth.authState;

  var history = (0, _reactRouterDom.useHistory)();

  if (!authState.isAuthenticated) {
    if (!authState.isPending) {
      var fromUri = history.createHref(history.location);
      authService.login(fromUri);
    }

    return null;
  }

  return _react2.default.createElement(_react2.default.Fragment, null, children);
};
/*
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */


var SecureRoute = function SecureRoute(_ref2) {
  var component = _ref2.component,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['component']);

  var PassedComponent = component || function () {
    return null;
  };

  var WrappedComponent = function WrappedComponent() {
    return _react2.default.createElement(RequireAuth, null, _react2.default.createElement(PassedComponent, null));
  };

  return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, props, {
    render: function render() {
      return props.render ? props.render((0, _extends3.default)({}, props, {
        component: WrappedComponent
      })) : _react2.default.createElement(WrappedComponent, null);
    }
  }));
};

exports.default = SecureRoute;